import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../config/firebase';
import AuthenticationService from '../services/AuthenticationService'; // Your backend caller

export const useGoogleSignIn = () => {
  const signIn = async ({ affiliate = null, newsletter = false } = {}) => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const idToken = await result.user.getIdToken();
      const response = await AuthenticationService.firebaseLogin({
        token: idToken,
        user_service: false,
        affiliate: affiliate,  // From URL/search params TODO
        newsletter: newsletter
      });
      return response; // { sessionId, accessToken, etc. }
    } catch (error) {
      throw error;
    }
  };
  return { signIn };
};
